import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton, IContextualMenuItem, Shimmer } from '@fluentui/react';
import { useJumpToOnMenuOpenedFunction } from './useOnMenuOpenedFunction';

/**
 * Dropdown menu for navigating to sections of the vulnerability details
 * page.
 */
export const VulnerabilityJumpTo = ({ isLoading }: { isLoading?: boolean }) => {
  const [t] = useTranslation(['vulnerability']);
  const [items, setItems] = useState<IContextualMenuItem[] | undefined>(
    undefined
  );

  const onMenuOpened = useJumpToOnMenuOpenedFunction({
    setItems,
  });

  if (isLoading) {
    return (
      <Shimmer
        styles={{
          root: {
            marginTop: '1em',
          },
        }}
      />
    );
  }

  return (
    <ActionButton
      menuProps={{
        onMenuOpened,
        onMenuDismissed: () => setItems(undefined),
        items: items || [],
        onItemClick: (_e, item) => {
          if (!item) {
            return;
          }
          item.onClick?.();
        },
      }}
    >
      {t('On this page', { defaultValue: 'On this page', ns: 'vulnerability' })}
    </ActionButton>
  );
};
